import { shd } from '@shd/jslib/models';

export const getPlayerName = (
  isAdmin: boolean,
  player: shd.TeamPlayer | shd.ClaimedPlayer | shd.Player | null
) => {
  if (!player) {
    return '';
  }
  if (isAdmin) {
    return `${player.nameFirst} ${player.nameLast}`;
  } else if (player.isNameOnPublicWebsite) {
    return getPrivacyName(
      player.nameFirst,
      player.nameLast,
      player.embedNameFirstLevel,
      player.embedNameLastLevel
    );
  } else {
    return '';
  }
};

export const getPrivacyName = (
  nameFirst: string,
  nameLast: string,
  embedNameFirstLevel: number,
  embedNameLastLevel: number
) => {
  let displayName;
  if (embedNameFirstLevel + embedNameLastLevel < 2) {
    displayName = '';
  } else {
    let displayNameFirst;
    let displayNameLast;
    if (!nameFirst) {
      displayNameFirst = '';
    } else if (embedNameFirstLevel === 2) {
      displayNameFirst = nameFirst;
    } else if (embedNameFirstLevel === 1) {
      displayNameFirst = `${nameFirst.slice(0, 1)}.`;
    } else {
      displayNameFirst = '';
    }

    if (!nameLast) {
      displayNameLast = '';
    } else if (embedNameLastLevel === 2) {
      displayNameLast = nameLast;
    } else if (embedNameLastLevel === 1) {
      displayNameLast = `${nameLast.slice(0, 1)}.`;
    } else {
      displayNameLast = '';
    }

    if (displayNameFirst.includes('.') && displayNameLast.includes('.')) {
      displayName = `${displayNameFirst}${displayNameLast}`;
    } else if (displayNameFirst && displayNameLast) {
      displayName = `${displayNameFirst} ${displayNameLast}`;
    } else if (displayNameFirst || displayNameLast) {
      displayName = displayNameFirst || displayNameLast;
    } else {
      displayName = '';
    }
  }
  return displayName;
};

export const compareJerseyNum = (a: shd.TeamPlayer, b: shd.TeamPlayer) => {
  const parsedA = parseInt(a.jerseyNum);
  const parsedB = parseInt(b.jerseyNum);

  const first = Number.isNaN(parsedA) ? Number.MAX_SAFE_INTEGER : parsedA;
  const second = Number.isNaN(parsedB) ? Number.MAX_SAFE_INTEGER : parsedB;
  if (first < second) {
    return -1;
  }
  if (first > second) {
    return 1;
  }

  return 0;
};

export const insertDisplayName = (player: shd.TeamPlayer) => {
  let displayName = '';
  let displayNameFull = '';
  if (player.nameFirst && player.nameLast) {
    displayName = `${player.nameFirst} ${player.nameLast}`;
  } else {
    displayName = player.nameFirst || player.nameLast;
  }
  if (displayName && player.jerseyNum) {
    displayNameFull = `#${player.jerseyNum} ${displayName}`;
  } else if (player.jerseyNum) {
    displayNameFull = `#${player.jerseyNum}`;
  } else {
    displayNameFull = displayName;
  }

  return { ...player, displayName: displayNameFull };
};

export const getRevenueCatUserId = (userId: string | undefined): string => {
  if (!userId) {
    return '';
  }
  const isProd = import.meta.env.VITE_APP_FIREBASE_CONFIG === 'production';
  return isProd ? userId : `dev__${userId}`;
};

export const shouldPromptForAccountInfo = (
  nameFirst?: string | null,
  nameLast?: string | null
): boolean => {
  const isEmpty = (str: string | null | undefined): boolean =>
    str === null || str === undefined || str.trim() === '';

  // Check if both names are empty/null
  const areBothNamesEmpty = isEmpty(nameFirst) && isEmpty(nameLast);

  // Check if names are "unknown signin"
  const isUnknownSignin =
    nameFirst?.toLowerCase().trim() === 'unknown' &&
    nameLast?.toLowerCase().trim() === 'signin';

  return areBothNamesEmpty || isUnknownSignin;
};
